import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isFirstRunComplete } from '../pages/FirstRunSetup';

const SessionLoader = () => (
  <div className="auth-screen flex h-screen items-center justify-center text-sm auth-muted">
    Verificando sessao...
  </div>
);

const Gateway: React.FC = () => {
  const { user, isLoading } = useAuth();

  // First-run wizard only applies to Electron (desktop) installs.
  // On the web, users land directly on the public landing page.
  const isElectron = typeof window !== 'undefined' && !!(window as any).electronAPI?.isElectron;
  if (isElectron && !isFirstRunComplete()) {
    return <Navigate to="/setup" replace />;
  }

  if (isLoading) {
    return <SessionLoader />;
  }

  if (!user) {
    return <Navigate to="/welcome" replace />;
  }

  return <Navigate to="/centro-operacional" replace />;
};

export default Gateway;
